import React from 'react';
import { OS_ENUMS, getMobileOperatingSystem } from '@/utils/operatingSystem';
import useInstallAppOverlayActions from './useInstallAppOverlayActions';

function InstallAppInstructionsOverlay() {
  const {showInstallAppOverlay, closeIntallAppOverlay} = useInstallAppOverlayActions();

  if (!showInstallAppOverlay) return;

  const os = getMobileOperatingSystem();
  const getScreenText = () => {
    let pageContent = <span>{'Feature not supported for the device type.'}</span>;
    if (os === OS_ENUMS.ios) {
      pageContent = (
        <>
          <span>Click (</span>
          <img
            className={'tw-h-[20px] tw-w-[20px]'}
            alt="share logo"
            src="/assets/images/ios_share_icon.png"
          />
          <span>) then 'Add to Home screen' from browser menu to add your store app for easy access.</span>
        </>
      );
    } else if (os === OS_ENUMS.android) {
      pageContent = (
        <>
          <span>Click (</span>
          <img
            className={'tw-h-[20px] tw-w-[20px]'}
            alt="3 dots logo"
            src="/assets/images/3_dots_white_icon.png"
          />
          <span>) then 'Add to home screen'/'Install App' from browser menu to add your store app for easy access.</span>
        </>
      );
    }

    return pageContent;
  };

  return (
    <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[999] tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-[#000000df]">
      <h3 className="tw-m-0 tw-mb-2 tw-mt-48 tw-w-[70%] tw-text-left tw-text-white">
        Add your store app
      </h3>
      <div className="tw-w-[70%] tw-text-left tw-text-white">{getScreenText()}</div>
      <div className="tw-mt-3 tw-flex tw-w-[60%] tw-justify-end">
        <button
          onClick={() => {
            closeIntallAppOverlay();
          }}
          type="button"
          className="tw-rounded-lg tw-bg-white tw-px-3 tw-py-2 tw-text-center tw-text-xs tw-font-medium tw-text-black hover:tw-opacity-70"
        >
          Okay
        </button>
      </div>
    </div>
  );
}

export default InstallAppInstructionsOverlay;
